import { TypographyVariants } from 'craft/constants';

// These defaults need to be strings explicitly as we strip falsey values in craftNodeToDocumentNode
const defaultSpacing = {
  marginTop: '0',
  marginBottom: '0',
  marginLeft: '0',
  marginRight: '0',
  paddingTop: '0',
  paddingBottom: '0',
  paddingLeft: '0',
  paddingRight: '0',
};

export const h1 = {
  ...defaultSpacing,
  paddingBottom: 8,
};

export const h2 = {
  ...defaultSpacing,
  paddingBottom: 8,
};

export const h3 = {
  ...defaultSpacing,
  paddingBottom: 8,
};
export const h4 = {
  ...defaultSpacing,
  paddingBottom: 8,
};

export const p = {
  ...defaultSpacing,
  paddingBottom: 4,
};

export const typographyStyles = {
  [TypographyVariants.H1]: h1,
  [TypographyVariants.H2]: h2,
  [TypographyVariants.H3]: h3,
  [TypographyVariants.H4]: h4,
  [TypographyVariants.P]: p,
};

export default typographyStyles;
